import { Typography, styled } from '@mui/material';
export const TypographyStyled = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: '2rem',
    // marginBottom: theme.spacing(2),
}));
